import React from 'react';
import { Link } from 'react-router-dom';

export default function BestSolutions() {
    return (
        <>
        <div className="px-4 px-lg-5 pb-4">
          <div className="row g-0 custom-scroll">
             
            <div className="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <Link to='/service/liferay-consultation-and-solutions'>
                <div className="our-service-container set-blue">
                  <div className="text-center service-card-text">Liferay Consultation and Solutions</div>
                  <div className="text-center service-card-sub-text">Liferay solutions to enhance digital experiences, streamline operations and support business growth.</div>
                  <div className="service-img-conainer">
                    <img src="/images/service/liferay-cms-devlopment.png" width={100} alt="Liferay-Solutions" />
                  </div>
                </div>
              </Link>
            </div>
            
            <div className="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <Link to='/service/managed-services'>
                <div className="our-service-container set-purple">
                  <div className="text-center service-card-text">Managed Services</div>
                  <div className="text-center service-card-sub-text">Maximize efficiency with our proactive IT support, infrastructure management, security, and continuous monitoring for seamless operations.</div>
                  <div className="service-img-conainer">
                    <img src="/images/service/web-solutions.png" width={100} alt="Managed-Services" />
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <Link to='/service/embedded-systems'>
                <div className="our-service-container set-blue">
                  <div className="text-center service-card-text">Embedded Systems</div>
                  <div className="text-center service-card-sub-text">Leverage the power of Embedded C and C++ in custom Embedded solutions, delivering enhanced functionality and performance for your system.</div>
                  <div className="service-img-conainer">
                    <img src="/images/service/service-embeddedsysytem.png" width={100} alt="Cloud-Solutions" />
                  </div>
                </div>
              </Link>
            </div>
            {/* <div className="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <Link to='/service/industrial-solutions'>
                <div className="our-service-container set-blue">
                  <div className="text-center service-card-text">Industrial Engineering Solutions</div>
                  <div className="text-center service-card-sub-text">Enhance efficiency, streamline processes and reduce costs with our tailored industrial engineering solutions for your business.</div>
                  <div className="service-img-conainer">
                    <img src="/images/service/industrial.png" alt="Industrial-Engineering-Solutions" />
                  </div>
                </div>
              </Link>
            </div> */}

            <div className="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <Link to='/service/testing'>
                <div className="our-service-container set-purple">
                  <div className="text-center service-card-text">Testing Manual / Automation</div>
                  <div className="text-center service-card-sub-text">Ensure quality with our manual and automated testing, offering thorough validation, efficiency and reliability for your software.</div>
                  <div className="service-img-conainer">
                    <img src="/images/service/enterprise-solution.png" width={100} alt="Testing" />
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <Link to='/service/ai-ml-development'>
                <div className="our-service-container set-blue">
                  <div className="text-center service-card-text">AI/ML Development</div>
                  <div className="text-center service-card-sub-text">Unlock innovation with our AI/ML development services, delivering intelligent, data-driven solutions for enhanced decision-making and efficiency.</div>
                  <div className="service-img-conainer">
                    <img src="/images/service/aiml.png" width={100} alt="AI/ML-Development" />
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <Link to='/service/cloud-solutions'>
                <div className="our-service-container set-purple">
                  <div className="text-center service-card-text">Cloud Solutions</div>
                  <div className="text-center service-card-sub-text">Leverage our cloud solutions to improve scalability, enhance security and streamline operations, driving digital transformation and business growth.</div>
                  <div className="service-img-conainer">
                    <img src="/images/service/cloud.png" width={100} alt="Cloud-Solutions" />
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        </>
    )
};
